import type { BlokProps } from "@trydig/storyblok";
import type { ComponentProps } from "react";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Intro } from "@/components/ui/Intro";
import type { BlokIntro } from "@/storyblok";

export const IntroBlok = ({
	blok,
	breadcrumbs,
	preview: _,
	...rest
}: BlokProps<BlokIntro> &
	Pick<ComponentProps<typeof Intro>, "breadcrumbs">) => {
	return (
		<BlokWrap editable={blok} asChild {...rest}>
			<Intro
				title={blok.title}
				preamble={blok.preamble}
				breadcrumbs={breadcrumbs}
				layout={blok.layout}
				lightMode={blok.lightMode}
			/>
		</BlokWrap>
	);
};
